<template>
	<div class='lmAes-demo-cases'>
    <h2>部分案例</h2>
    <div class="box">
      <img src="../assets/images/lmaesDemoCases.png"/>
      </div>
	</div>
</template>

<script>
	export default {
		name: 'LmAesDemoCases'
	}
</script>

<style scoped>
@media(min-width:992px) {
  .lmAes-demo-cases {
      background: #ffffff;
      padding: 4.16vw 0;
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .lmAes-demo-cases h2 { 
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #3963B3;
      line-height: 33px;
      text-align: left;
      font-style: normal;
    }
    .lmAes-demo-cases .box {
      width: 100%;
      margin: 40px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lmAes-demo-cases .box img {
      width: 76.38vw;
      height: 31.39vw;
    }  
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/LmAesDemoCases.vue